import { render, staticRenderFns } from "./HistoriesList.vue?vue&type=template&id=785d097d&"
import script from "./HistoriesList.vue?vue&type=script&lang=js&"
export * from "./HistoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports